import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-0.5,-2.5h0.5v0.5h-0.5zM-0.5,-2h1v2h-1zM0,0h1v0.5h-1z' },
    {
      paint: 'evergreenDark',
      d: 'M0,-11.5h0.5v1h-0.5zM0,-10.5h1v1h-1zM0,-9.5h1.5v0.5h-1.5zM0.5,-9h1v0.5h-1zM0,-8.5h2v2h-2zM-0.5,-6.5h2.5v0.5h-2.5zM-0.5,-6h3v0.5h-3zM0,-5.5h3v0.5h-3zM0,-5h2.5v0.5h-2.5zM0,-4.5h3v0.5h-3zM-0.5,-4h3.5v0.5h-3.5zM-0.5,-3.5h4v0.5h-4zM-1,-3h4.5v0.5h-4.5zM-3,-2.5h2.5v0.5h-2.5zM0,-2.5h3v0.5h-3z',
    },
    {
      paint: 'pine',
      d: 'M-0.5,-12h0.5v0.5h-0.5zM-1,-11.5h0.5v0.5h-0.5zM-0.5,-11h0.5v2h-0.5zM-2,-9h0.5v0.5h-0.5zM-1,-9h1.5v0.5h-1.5zM-2,-8.5h2v0.5h-2zM-1.5,-8h1.5v0.5h-1.5zM-2,-7.5h2v0.5h-2zM-2.5,-7h0.5v1h-0.5zM-1,-7h1v0.5h-1zM-1,-6.5h0.5v0.5h-0.5zM-3,-6h2.5v0.5h-2.5zM-3,-5.5h3v0.5h-3zM-2.5,-5h2.5v0.5h-2.5zM-3,-4.5h3v0.5h-3zM-3.5,-4h3v1h-3zM-4,-3h3v0.5h-3z',
    },
    {
      paint: 'evergreenLight',
      d: 'M-0.5,-11.5h0.5v0.5h-0.5zM-1,-11h0.5v1h-0.5zM-1.5,-10h1v1h-1zM-1.5,-9h0.5v0.5h-0.5zM-2,-7h1v1h-1z',
    },
  ],
  pixels: 181,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M-0.5,-1.5h1v1.5h-1zM0,0h1v0.5h-1z' },
    {
      paint: 'evergreenDark',
      d: 'M-0.5,-8.5h0.5v0.5h-0.5zM0,-8h0.5v1h-0.5zM0,-7h1v0.5h-1zM0,-6.5h1.5v0.5h-1.5zM0,-6h2v1h-2zM0,-5h2.5v0.5h-2.5zM0,-4.5h3v2h-3zM0,-2.5h3.5v0.5h-3.5zM-1,-2h4.5v0.5h-4.5zM1.5,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'pine',
      d: 'M-1,-8.5h0.5v0.5h-0.5zM-0.5,-8h0.5v2h-0.5zM-2,-6.5h0.5v0.5h-0.5zM-2,-6h2v1h-2zM-2.5,-5h0.5v0.5h-0.5zM-1,-5h1v0.5h-1zM-3,-4.5h0.5v0.5h-0.5zM-1.5,-4.5h1.5v0.5h-1.5zM-3,-4h3v1h-3zM-3.5,-3h3.5v1h-3.5zM-4,-2h3v0.5h-3z',
    },
    {
      paint: 'evergreenLight',
      d: 'M-1,-8h0.5v0.5h-0.5zM-1.5,-7.5h1v1.5h-1zM-2,-5h1v0.5h-1zM-2.5,-4.5h1v0.5h-1z',
    },
  ],
  pixels: 136,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z' },
    { paint: 'trunk', d: 'M0,-3h1v1.5h-1zM-0.5,-1.5h1.5v0.5h-1.5zM-0.5,-1h1v1h-1zM0,0h1v0.5h-1z' },
    {
      paint: 'evergreenDark',
      d: 'M1.5,-11h0.5v1h-0.5zM2,-10h0.5v1.5h-0.5zM2,-8.5h1v0.5h-1zM1.5,-8h1.5v0.5h-1.5zM1.5,-7.5h2v0.5h-2zM1,-7h2v1h-2zM1,-6h2.5v2h-2.5zM0.5,-4h3.5v0.5h-3.5zM-0.5,-3.5h4.5v0.5h-4.5zM-1.5,-3h1.5v0.5h-1.5zM1,-3h3v0.5h-3z',
    },
    {
      paint: 'pine',
      d: 'M1,-11.5h1v0.5h-1zM1,-10h1v1h-1zM0.5,-9h1.5v0.5h-1.5zM-0.5,-8.5h2.5v0.5h-2.5zM-0.5,-8h2v0.5h-2zM-1,-7.5h0.5v0.5h-0.5zM0.5,-7.5h1v0.5h-1zM-1.5,-7h0.5v0.5h-0.5zM0,-7h1v0.5h-1zM-1.5,-6.5h2.5v0.5h-2.5zM-1,-6h2v0.5h-2zM-1.5,-5.5h2.5v0.5h-2.5zM-2,-5h3v1h-3zM-2.5,-4h3v0.5h-3zM-2.5,-3.5h2v0.5h-2z',
    },
    {
      paint: 'evergreenLight',
      d: 'M1,-11h0.5v0.5h-0.5zM0.5,-10.5h1v0.5h-1zM0.5,-10h0.5v0.5h-0.5zM0,-9.5h1v0.5h-1zM-0.5,-9h1v0.5h-1zM-0.5,-7.5h1v0.5h-1zM-1,-7h1v0.5h-1z',
    },
  ],
  pixels: 156,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
